window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});
// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}
// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-378882101");
  window.gtag("event", "purchase", {
    send_to: ["G-WCN3C8KG6R", "AW-378882101/7TleCNuDyPoCELWQ1bQB"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
  });
}


// Breeze begin checkout

window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});
// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}
// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  // paste the snippet out here

    gtag("js", new Date());
  gtag("config", "AW-378882101");
  window.gtag("event", "begin_checkout", {
    send_to: ["G-WCN3C8KG6R", "AW-378882101/7TleCNuDyPoCELWQ1bQB"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
  });

}